import React, { useEffect, useState, useRef } from 'react';

import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
import {  Card } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import {  TextField, Button, Checkbox,Container } from '@mui/material';

import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import {  Backdrop, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText,  Grid, FormControlLabel } from '@mui/material';



export default function PlaceLocator() {
    const [open, setOpen] = React.useState(false);
 

    const [iCode, setICode] = useState('');
    const [iDescription, setIDescription] = useState('');
    const [productStatus, setProductStatus] = useState('');
    const [customer, setCustomer] = useState('');
    const [invoice, setInvoice] = useState('');
    const [invDate, setInvDate] = useState('');
    const [name, setName] = useState('');
    const [place, setPlace] = useState('');
    const [mobile, setMobile] = useState('');
    const [error, setError] = useState(null);
    const [serialNumberDetails, setSerialNumberDetails] = useState(null);
    const [serialNumber, setSerialNumber] = useState('');
    const [serialNumber1, setSerialNumber1] = useState('');
    const [returnReason, setReturnReason] = useState('');
    
    const [stock, setStock] = useState('');
   var LOGINID = localStorage.getItem('LOGIN_ID')
    //r LOGINID = 5100735
   

 
    const [showDetails, setShowDetails] = useState(false);

    const handleViewClick = () => {
      setOpen(true);
    setSerialNumber1(serialNumber);
        axios.post(BASE_URL+'/getSerialNumberDetails',{login_id:LOGINID,serial_no:serialNumber})
        .then(response => {
            const data = response.data;
          if (data.status_code === '200' && data.data.length > 0) {
          
            setOpen(false);
            const details = data.data[0]; 
            if(details.Msg){
              setOpen(false);
                setShowDetails(false);
          Swal.fire({
                            icon: 'info',
                            text: 'No Record Found',
                        });
               
            }
            else
            {
              setOpen(false);
                setShowDetails(true);
            }
            // Accessing the first item of the array
            setICode(details.ICode.trim());
            setIDescription(details.IDescription);
            setProductStatus(details.ProductStatus);
            setCustomer(details.Customer);
            setInvoice(details.Invoice);
            setInvDate(details.InvDate);
            setName(details.Name);
            setPlace(details.Place);
            setMobile(details.Mobile);
          } else {
            setOpen(false);
            setError('No data found');
          }
        })
        .catch(error => {
          setOpen(false);
          console.error('Error fetching serial number details:', error);
          setError(error.message || 'An error occurred');
        });
      
    };
  


    const DealerDetails = () => {
        setOpen(true);

        
    }
    const handleSerialNumberChange = (event) => {
      
      const inputValue = event.target.value;

      // Regex pattern to match only positive integers excluding 0
      const validInput = /^[a-zA-Z1-9]\w*$/;

      // Check if input matches the valid pattern or is an empty string
      if (validInput.test(inputValue) || inputValue === '') {
          // Update state with valid input
          setSerialNumber(inputValue);
      }
      // You can optionally add an else condition to display a warning or error message
  };

  
    // const handleSerialNumberChange = (event) => {
      
    //     setSerialNumber(event.target.value);
    //   };

 
      const handleSaveSubmit = async () => {
        setOpen(true);
        // Ensure mandatory fields are not empty
        // if (!serialNumber || !invoice || !invDate || !dealerCode || !itemCode || !itemDescription || !returnReason || !stock) {
        //     Swal.fire({
        //         icon: "warning",
        //         text: 'Please fill in all the required fields.'
        //     });
        //     return;
        // }

        if(serialNumber!=serialNumber1)
          {
            setOpen(false);
            Swal.fire({
                      icon: "warning",
                      text: 'Serial Number is not Valid'
                  });
                  return;
                  

          }

        const stockValue = document.getElementById('chkStock').checked ? 'Y' : 'N';

        // Prepare data for the API call
        const data = {
            serial_no: serialNumber,
            login_id: LOGINID,
            dealerCode: name,
            invoiceNo: invoice,
            invDate: invDate,
            itemCode: iCode,
            itemDescription: iDescription,
            returnReason: returnReason,
            stock: stockValue
        };

        
        axios.post(BASE_URL + '/SalesReturnEntrycreate', data)
            .then(response => {
                if (response.status === 200) {
                  setOpen(false);
                    Swal.fire({
                        icon: "success",
                        text: 'Sale Return Done Successfully!'
                    }).then(() => {
                     setICode('');
                     setIDescription('');
                     setProductStatus('');
                        setSerialNumber('');
                        setInvoice('');
                        setInvDate('');
                        setReturnReason('');
                        setStock('');
                        setName('');
                        setMobile('');
                        setPlace('');
                    });
                 
                } else {
                  setOpen(false);
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
              if (error.response) {
                setOpen(false);
                const messages = error.response.data.message;
                let messageHTML = '<ul style="text-align: left;">';
                messages.forEach(message => {
                    // Remove the word "field" from each error message
                    const cleanMessage = message.replace(/ field /g, ' ');
                    messageHTML += `<li>${cleanMessage}</li>`;
                });
                messageHTML += '</ul>';
            
                Swal.fire({
                    icon: "warning",
                    title: "Required",
                    html: messageHTML
                });
            }
            
            
            else if (error.request) {
                  setOpen(false);
                    Swal.fire({
                        icon: "error",
                        text: `No response received`
                    });
                } else {
                  setOpen(false);
                  Swal.fire({
                      icon: "info",
                      text: "Error encountered:",
                      html:
                          `<ul style="text-align: left;">
                              <li>The request could not be processed.</li>
                              <li>${error.message}</li>
                          </ul>`
                  });
              }
              
            });
    };
    

    return (
        <Container>
          <div className="m-4">
    <Card className="shadow bg-white rounded">
    <h4 style={{ padding: '5px', background: '#e3fafe', color: 'black' }} > Sales Return Entry</h4>
    <br/>
  
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
            <label htmlFor="item-description"><b>Product Serial Number</b></label>
            <TextField
        fullWidth
        id="view-field"
        label=""
        variant="outlined"
        value={serialNumber}
        onChange={handleSerialNumberChange}
      />
            </Grid>
            <Grid item xs={12} sm={6}>
            <Button style={{marginTop:"37px"}}fullWidth variant="contained" endIcon={<RemoveRedEyeRoundedIcon />} onClick={handleViewClick} ><b>View</b></Button>
                </Grid> 
        </Grid>
    </Card>
</div>

<hr />
{showDetails && (

<div className="m-4">
<Card className="shadow bg-white rounded">
<h4 style={{ padding: '5px', background: '#e3fafe', color: 'black' }} > Product Details </h4>
      <Grid container spacing={2}>
   
        <Grid item xs={6}>
          <label htmlFor="iCode"><b>Item Code</b></label>
          <TextField
             InputProps={{ readOnly: true }}
            fullWidth
            id="iCode"
            variant="outlined"
            value={iCode}
            onChange={(event) => setICode(event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <label htmlFor="iDescription"><b>Item Description</b></label>
          <TextField
            InputProps={{ readOnly: true }}
            fullWidth
            id="iDescription"
            variant="outlined"
            value={iDescription}
            onChange={(event) => setIDescription(event.target.value)}
            
          />
        </Grid>
        <Grid item xs={6}>
          <label htmlFor="productStatus"><b>Product Status</b></label>
          <TextField
             InputProps={{ readOnly: true }}
            fullWidth
            id="productStatus"
            variant="outlined"
            value={productStatus}
            onChange={(event) => setProductStatus(event.target.value)}
            
          />
        </Grid>
        <Grid item xs={6}>
        
        </Grid>
        </Grid>
        </Card>
        <br/>
        <br/>
        <Card className="shadow bg-white rounded">
        <h4 style={{ padding: '5px', background: '#e3fafe', color: 'black' }} > {customer} </h4>
        <Grid container spacing={2}>
       
        
        <Grid item xs={6}>
          <label htmlFor="name"><b>Name</b></label>
          <TextField
             InputProps={{ readOnly: true }}
            fullWidth
            id="name"
            variant="outlined"
            value={name}
            onChange={(event) => setName(event.target.value)}
            
          />
        </Grid>
        <Grid item xs={6}>
          <label htmlFor="place"><b>Place</b></label>
          <TextField
              InputProps={{ readOnly: true }}
            fullWidth
            id="place"
            variant="outlined"
            value={place}
            onChange={(event) => setPlace(event.target.value)}
            
          />
        </Grid>
        <Grid item xs={6}>
          <label htmlFor="mobile"><b>Mobile</b></label>
          <TextField
             InputProps={{ readOnly: true }}
            fullWidth
            id="mobile"
            variant="outlined"
            value={mobile}
            onChange={(event) => setMobile(event.target.value)}
            
          />
        </Grid>
        <Grid item xs={6}>
          <label htmlFor="invoice"><b>Invoice Number</b></label>
          <TextField
           
            fullWidth
            id="invoice"
            variant="outlined"
            value={invoice}
            onChange={(event) => setInvoice(event.target.value)}
            InputProps={{ readOnly: true }}
            
          />
        </Grid>
        <Grid item xs={6}>
          <label htmlFor="invDate"><b>Invoice Date</b></label>
          <TextField
             InputProps={{ readOnly: true }}
            fullWidth
            id="invDate"
            variant="outlined"
            value={invDate}
            onChange={(event) => setInvDate(event.target.value)}
            
          />
        </Grid>
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
          <label htmlFor="invDate"><b>Reason for Return(Mandatory *)</b></label>
          <TextField
                                fullWidth
                                id="return-reason"
                                variant="outlined"
                                multiline
                                rows={3}
                                value={returnReason}
                                onChange={(e) => setReturnReason(e.target.value)}
                                
                            />
        </Grid>
        <Grid item xs={6}> </Grid>
<Grid item xs={12}>
<Checkbox id="chkStock" />
            <label htmlFor="chkStock">
              <b>
By performing this operation the Goods will be taken back and will be added in my stock
</b>
</label>
</Grid>
        
   
        <Grid item xs={12}>
          <Button fullWidth variant="contained" color="primary" onClick={handleSaveSubmit}>Save</Button>
        </Grid>
      </Grid>
    </Card>
</div>
)}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                <CircularProgress color="inherit" />
            </Backdrop>
           
       </Container>
    );
}

